export const APP_COOKIE_KEY_PREFIX = '@CROWNBIT_COOKIE_KEY';
export const COOKIE_KEY_THEME_MODE = `${APP_COOKIE_KEY_PREFIX}::THEME_MODE`;
export const COOKIE_KEY_APP_SIDE_BAR_OPEN_STATUS = `${APP_COOKIE_KEY_PREFIX}::APP_SIDE_BAR_OPEN_STATUS`;
export const COOKIE_KEY_APP_LOCAL_LANGUAGE = `${APP_COOKIE_KEY_PREFIX}::APP_LOCAL_LANGUAGE`;

export const COOKIE_KEY_USER_INFO = `${APP_COOKIE_KEY_PREFIX}::USER_INFO`;
export const COOKIE_KEY_USER_TOKEN = `${APP_COOKIE_KEY_PREFIX}::USER_TOKEN`;
